import GeneralModal from '../../components/GeneralModal/GeneralModal'
import TextInput from '../../components/TextInput/TextInput'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'
import { useState } from 'react'
import useDebounce from '../../utils/hooks/useDebounce'
import { usePortfolioSlugCheckMutation, useSessionQuery } from '../../api/api'
import SlugTextInput from '../../components/TextInput/SlugTextInput'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'

const PortfolioDuplicateModal = ({
  portfolio,
  isOpen,
  onRequestClose,
  onSubmit,
  isLoading,
}) => {
  const [values, setValues] = useState({
    name: `${portfolio.name} Copy`,
    slug: '',
    id: portfolio.id,
  })
  const [isOutOfDate, setIsOutOfDate] = useState(false)
  const [fetchCheckSlug, { isLoading: isLoadingSlug, data }] =
    usePortfolioSlugCheckMutation()
  const debouncedCheckSlug = useDebounce(500)

  function handleNameChange(evt) {
    setValues({ ...values, name: evt.target.value })
  }
  function handleSlugChange(evt) {
    const value = evt.target.value
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^A-Za-z0-9_-]+/g, '')
    setValues({ ...values, slug: value })
    setIsOutOfDate(true)
    if (value) {
      if (domainCheck(value)) {
        debouncedCheckSlug(() => {
          fetchCheckSlug({ id: portfolio.id, slug: value }).then(() =>
            setIsOutOfDate(false),
          )
        })
      }
    }
  }

  function domainCheck(slug) {
    try {
      new URL(`https://sharefol.io/${slug}`)
      return true
    } catch (err) {
      return false
    }
  }

  function canSubmit() {
    const { name, slug } = values
    return (
      name &&
      (!slug ||
        (!isOutOfDate && !isLoadingSlug && data?.isValid && domainCheck(slug)))
    )
  }

  function handleSubmit() {
    if (canSubmit()) {
      onSubmit(values)
    }
  }

  return (
    <GeneralModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Duplicate Portfolio"
      buttons={[
        {
          className: 'button bg-pink',
          text: 'Duplicate',
          disabled: !canSubmit(),
          onClick: handleSubmit,
        },
      ]}
    >
      <div>
        <TextInput
          label="Name *"
          value={values.name}
          name="name"
          onChange={handleNameChange}
          onEnter={handleSubmit}
        />
      </div>
      <div className="relative mt-4">
        <SlugTextInput
          value={values.slug}
          onChange={handleSlugChange}
          onEnter={handleSubmit}
        />
        {isLoadingSlug ? (
          <div className="absolute right-[10px] top-[31px]">
            <LoadingSpinner size="small" />
          </div>
        ) : null}
      </div>
      {values?.slug && !isOutOfDate && data?.isValid === false ? (
        <div className="p-4 bg-pink-dark rounded border border-pink-error my-4">
          That link is already in use by another one of your portfolios. Please
          choose another one.
        </div>
      ) : null}

      <div className="text-sm text-white-dark mt-2">
        If you don't provide a link, one will be automatically generated.
      </div>
      {isLoading ? <LoadingBlocker /> : null}
    </GeneralModal>
  )
}

export default PortfolioDuplicateModal
